import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Switch } from 'react-router-dom'
import FrontendAuth from "./FrontendAuth";
import routerMap from "./routerMap";
import { cppGetAppInfo } from './api/cpp';
import { compareVersions } from "./utils/index";
import WafCaptchaDia from "./componts/Common/WafCaptchaDia/WafCaptchaDia";
import RateLimitDialog from "./componts/Common/RateLimitDialog/RateLimitDialog";
import RestrictedDia from "./componts/Common/RestrictedDia/RestrictedDia";
import { wafCaptchaManager } from "./utils/wafCaptchaManager";
const appInfo = cppGetAppInfo();

const Root = () => {
    // 登录状态
    const [loginValid, setLoginValid] = useState(false);
    // 安全验证验证码弹框
    const [showCaptcha, setShowCaptcha] = useState(false);
    // 请求速率限制弹框
    const [showRateLimit, setShowRateLimit] = useState(false);
    const [rateLimitMessage, setRateLimitMessage] = useState('');
    // 账号受限扫码解限弹框
    const [showRestricted, setShowRestricted] = useState(false);

    useEffect(() => {
        // 区分一下是新版还是旧版 旧版使用旧版背景图
        const isNew = compareVersions(appInfo && appInfo.version, "3.9.4");
        if (isNew) {
            const theme = window.localStorage.getItem('sy_theme');
            if (['default', 'anhui', 'canglv', 'mozi', 'yunhong'].includes(theme)) {
                document.getElementsByTagName('body')[0].setAttribute('datatheme', theme);
            }
        } else {
            document.getElementsByTagName('body')[0].setAttribute('datatheme', "default");
        }

        wafCaptchaManager.onCaptchaVerified((needCaptcha) => {
            setShowCaptcha(needCaptcha);
        });

        wafCaptchaManager.onRateLimitChange((show, message) => {
            setShowRateLimit(show);
            setRateLimitMessage(message);
        });

        wafCaptchaManager.onRestrictedChange((needRestricted) => {
            setShowRestricted(needRestricted);
        });
    }, []);

    const handleCaptchaSuccess = () => {
        wafCaptchaManager.setNeedCaptcha(false);
        wafCaptchaManager.clearPendingRequests();
    };

    const handleCaptchaClose = () => {
        wafCaptchaManager.setNeedCaptcha(false);
        const pendingRequests = wafCaptchaManager.getPendingRequests();
        pendingRequests.forEach(err => {
            if (err._captchaReject) {
                err._captchaReject(err);
            }
        });
        wafCaptchaManager.clearPendingRequests();
    };

    const handleRateLimitClose = () => {
        wafCaptchaManager.setShowRateLimit(false, '');
    };

    const handleRestrictedSuccess = () => {
        wafCaptchaManager.setNeedRestricted(false);
        wafCaptchaManager.notifyRestrictedResolved();
    };

    const handleRestrictedClose = () => {
        wafCaptchaManager.setNeedRestricted(false);
    };

    return (
        <Router>
            <Switch>
                <FrontendAuth routerConfig={routerMap} loginValid={loginValid} setLoginValid={setLoginValid} />
            </Switch>
            <WafCaptchaDia
                isOpen={showCaptcha}
                onClose={handleCaptchaClose}
                onSuccess={handleCaptchaSuccess}
            />
            <RateLimitDialog
                isOpen={showRateLimit}
                onClose={handleRateLimitClose}
                message={rateLimitMessage}
            />
            <RestrictedDia
                isOpen={showRestricted}
                onClose={handleRestrictedClose}
                onSuccess={handleRestrictedSuccess}
            />
        </Router>
    );
}

export default Root;
